import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../Store/store';
import EmailListSignup from '../EmailListSignup/EmailListSignup';

/**
 * Email Signup Box Component
 * 
 * A standalone component for collecting email signups.
 * Can be used on landing page and game screens.
 */
const EmailSignupBox: React.FC = () => {
    const { currentGame } = useSelector((state: RootState) => state.gameSession);
    const textColor = currentGame?.colorSecondary || 'rgba(255, 255, 255, 0.9)';

    return (
        <div style={{
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto'
        }}>
            <div>
                <p style={{
                    fontSize: "1.5rem", 
                    color: textColor, 
                    fontFamily: "Open Sans",
                    fontWeight: 700,
                    textAlign: 'center',
                    margin: '0 0 0.5rem 0',
                    lineHeight: 1.3
                }}>
                    Stay in the know
                </p>
                <p style={{
                    fontSize: "1rem",
                    color: textColor,
                    fontFamily: "Open Sans",
                    textAlign: 'center',
                    margin: '0 0 1.5rem 0',
                    opacity: 0.8
                }}>
                    Get notified about new games and updates
                </p>
            </div>
            <EmailListSignup />
        </div>
    );
};

export default EmailSignupBox;
